<div class="main">
  @if (!isHistory) {
    <div class="filterContainer">
      @if (headerList[0]) {
        <app-AutoDropdown
          [(SelectedValue)]="selectedUser"
          [onChangeFunction]="listViewUpdateFn"
          [items]="users"
          displayProperty="name"
          label="Søg Navn"
          >
        </app-AutoDropdown>
      }
      @if (headerList[1]) {
        <app-AutoDropdown
          [(SelectedValue)]="selectedInternalTitle"
          [onChangeFunction]="listViewUpdateFn"
          [items]="internalTitles"
          displayProperty="name"
          label="Søg Intern titel"
          >
        </app-AutoDropdown>
      }
      @if (headerList[2]) {
        <app-AutoDropdown
          [(SelectedValue)]="selectedDepartment"
          [onChangeFunction]="listViewUpdateFn"
          [items]="departments"
          displayProperty="displayName"
          label="Søg Afdeling"
          >
        </app-AutoDropdown>
      }
      @if (headerList[3]) {
        <app-AutoDropdown
          [defaultResetValue]="-1"
          [(SelectedValue)]="selectedManager"
          [onChangeFunction]="listViewUpdateFn"
          [items]="nearestManagers"
          displayProperty="name"
          label="Søg Nærmeste leder"
          >
        </app-AutoDropdown>
      }
    </div>
  }
  <div class="list-button-container">
    <div class="buttonContainer">
      <button
        mat-flat-button
        color="accent"
        class="createNewUserBtn"
        (click)="createNewUser()"
        >
        Ny Bruger
      </button>
    </div>

    @if (!isHistory) {
      <div class="list-container">
        <lib-list-view
          #listView
          [headerList]="headerList"
          (rowClick)="openUserDialog($event)"
          [filterFunction]="filterFunction"
          [extraBurgerMenuOptions]="extraBurgerMenuOptions"
          >
        </lib-list-view>
      </div>
    }

    @if (isHistory) {
      <div class="list-container">
        <lib-list-view
          #logListView
          [headerList]="logHeaderList"
          [filterFunction]="filterFunction"
          [extraBurgerMenuOptions]="extraBurgerMenuOptions"
          >
        </lib-list-view>
      </div>
    }
  </div>
</div>
